import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LogoState {
  logoUrl: string | null;
}

const initialState: LogoState = {
  logoUrl: null,
};

const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setLogo(state, action: PayloadAction<string | null>) {
      state.logoUrl = action.payload;
    },
  },
});

export const { setLogo } = logoSlice.actions;
export default logoSlice.reducer;